import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

// Appt Components
import Box from '../../components/simple/box/Box'
import Divider from '../../components/simple/divider/Divider.js'
import FontAwesome from '../../components/compound/fontAwesome/FontAwesome'

import ResponsiveGrid from '../../components/compound/responsiveGrid/ResponsiveGrid'
import Text from '../../components/simple/text/Text'
import SimpleCounterSmall from '../../components/compound/simpleCounterSmall/SimpleCounterSmall'
import ActionList from '../../components/compound/actionList/ActionList.js'

// Shared Components

import { Bar } from 'react-chartjs-2'

import LocalStorageService from '../../services/LocalStorageService'
import ReportService from '../../services/ReportService'

import { backgroundColours, borderColours } from '../reports/common/colours.js'
import ActionButton from '../../components/compound/actionButton/ActionButton.js'
import { openAnalyticsWithFilters } from '../../utils/analytics.js'

const ServiceUserProfileStats = (props) => {
    const location = useLocation()

    const [totalDurationPhysicalIntervention, setTotalDurationPhysicalIntervention] = useState(0)
    const [totalDurationPhysicalInterventionLabel, setTotalDurationPhysicalInterventionLabel] = useState('')
    const [averageDurationPhysicalIntervention, setAverageDurationPhysicalIntervention] = useState(0)
    const [averageDurationPhysicalInterventionLabel, setAverageDurationPhysicalInterventionLabel] = useState('')

    const [reportData, setReportData] = useState({})


    const [incidentDamageCountData, setIncidentDamageCountData] = useState([])
    const [commonInterventions, setCommonInterventions] = useState([])
    const [commonTechniques, setCommonTechniques] = useState([])
    const [commonPhysicalTechniques, setCommonPhysicalTechniques] = useState([])
    const [commonDeescalationTechniques, setCommonDeescalationTechniques] = useState([])
    const [breathingMonitoredByStudentGraph, setBreathingMonitoredByStudentGraph] = useState([])
    const [breathingMonitoredByYearGroupGraph, setBreathingMonitoredByYearGroupGraph] = useState([])
    const [breathingMonitoredByStudentGroupGraph, setBreathingMonitoredByStudentGroupGraph] = useState([])
    const [numIncidentsRestrictedInterventionUsed, setNumIncidentsRestrictedInterventionUsed] = useState(0)
    const [relatedIncidents, setRelatedIncidents] = useState([]);

    const [numIncidentsInvolvingInjuryToChild,setNumIncidentsInvolvingInjuryToChild] = useState(0);

    const [numIncidentsInvolvingInjuryToStaff,setNumIncidentsInvolvingInjuryToStaff] = useState(0);

    const [numIncidentsInvolvingInjuryToOthers,setNumIncidentsInvolvingInjuryToOthers] = useState(0);

    const [totalNumberOfIncidentsByStudentGroup,setTotalNumberOfIncidentsByStudentGroup] = useState([]);

    const [totalNumberOfIncidentsByDate,setTotalNumberOfIncidentsByDate] = useState([]);

    const [totalNumberOfIncidentsByHour,setTotalNumberOfIncidentsByHour] = useState([]);
    const [averageNumberOfStaffPerIncidentByLocation,setAverageNumberOfStaffPerIncidentByLocation] = useState([]);

    const [otherChildrenInvolvedInIncident,setOtherChildrenInvolvedInIncident] = useState([]);




    const terms = LocalStorageService.get('terms')
    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg');
    const userDetails = LocalStorageService.get('userDetails');

    const damageReportChartData = {
        labels: incidentDamageCountData[1],
        datasets: [
        {
            // label: '# of Incidents',
            data: incidentDamageCountData[0],
            backgroundColor: backgroundColours,
            borderColor: borderColours,
            borderWidth: 1,
        },
        ],
    };

    const printScreen = () => {
        window.print()
    }

  const loadReport = async () => {

    let responses = await ReportService.getReport(
        apiToken,
        {
            orgId: activeOrg.id,
            // limit: 100,
            // page: 1
        },
        {
            submissionType: 'incidentReport',
            query: [
                {
                "key": "studentName",
                    "operator": "is",
                    "response": props.userId,
                    "relation": null
                }
            ],
            reports: [
                "totalNumberOfIncidentsByStudent",
                "totalNumberOfIncidentsByYearGroup",
                "totalNumberOfIncidentsByStudentGroup",
                "totalNumberOfIncidentsByDate",
                "totalNumberOfIncidentsByHour",
                "totalNumberOfIncidentsByLocation",
                "totalNumberOfIncidentsBySystemUser",
                "totalNumberOfIncidents",
                "numberIncidentsPhysicalInterventionUsed",
                "numberIncidentsNoPhysicalInterventionUsed",
                "numberIncidentsRestrictedInterventionUsed",
                "commonIntervention",
                "commonTechnique",
                "commonDeescalationTechnique",
                "commonPhysicalTechnique",
                "incidentDamageCount",
                "numberIncidentsRestrictedInterventionUsed",
                "averageDurationPhysicalIntervention",
                "totalDurationPhysicalIntervention",
                "breathingMonitoredByStudentGraph",
                "breathingMonitoredByYearGroupGraph",
                "breathingMonitoredByStudentGroupGraph",
                'numIncidentsInvolvingInjuryToChild',
                'numIncidentsInvolvingInjuryToStaff',
                'numIncidentsInvolvingInjuryToOthers',
                'numIncidentsInvolvingInjuryByStudentGroup',
                'numIncidentsInvolvingInjuryWithOtherChildren'
            ],
        },
    )

    setReportData(responses)

  }

  useEffect(() => {
    loadReport()
  }, [location.pathname])

  useEffect(() => {
    // Map the API data in reportData into the relevant datasets

    // Common Interventions
    if (reportData.commonIntervention) {
      let commonIntervention = reportData.commonIntervention
      // sort by count desc
      if (commonIntervention?.length) commonIntervention.sort((a, b) => (a.count < b.count) ? 1 : -1)

      setCommonInterventions(commonIntervention.map((data) => {
        return {
          title: data.response + ' (' + data.count + ')',
          key: 'location',
          response: data.response
        }
      }))
    }

    // Common Techniques
    if (reportData.commonTechnique) {
      let commonTechnique = reportData.commonTechnique
      // sort by count desc
      if (commonTechnique?.length) commonTechnique.sort((a, b) => (a.count < b.count) ? 1 : -1)

      setCommonTechniques(commonTechnique.map((data) => {
        return {
          title: data.response + ' (' + data.count + ')',
          key: 'location',
          response: data.response
        }
      }))
    }

    // Common Techniques
    if (reportData.commonPhysicalTechnique?.length) {
      let commonPhysicalTechnique = reportData.commonPhysicalTechnique
      if (commonPhysicalTechnique?.length) commonPhysicalTechnique.sort((a, b) => (a.count < b.count) ? 1 : -1)
      commonPhysicalTechnique = commonPhysicalTechnique.map((data) => {
        // data.questionkey = data.questionkey + ' (' + data.count + ')'
        // return data
        return {
          title: data.questionkey + ' (' + data.count + ')',
          key: 'physicalInterventionTechnique',
          response: data.questionkey
        }
      })
      setCommonPhysicalTechniques(commonPhysicalTechnique)
    }

    // Common Techniques
    if (reportData.commonDeescalationTechnique?.length) {
      let commonDeescalationTechnique = reportData.commonDeescalationTechnique
      if (commonDeescalationTechnique?.length) commonDeescalationTechnique.sort((a, b) => (a.count < b.count) ? 1 : -1)
      commonDeescalationTechnique = commonDeescalationTechnique.map((data) => {
        // data.questionkey = data.questionkey + ' (' + data.count + ')'
        // return data
        return {
          title: data.questionkey + ' (' + data.count + ')',
          key: 'deescalationTechnique',
          response: data.questionkey
        }
      })
      setCommonDeescalationTechniques(commonDeescalationTechnique)
    }

    // Average Duration Physical Intervention
    if (reportData.averageDurationPhysicalIntervention !== undefined) {
      const averageDurationPhysicalIntervention = reportData.averageDurationPhysicalIntervention
      if (averageDurationPhysicalIntervention?.value?.[0]?.average) {

        // convert minutes to a string with minutes and seconds
        const averageDurationPhysicalInterventionValue = parseFloat(averageDurationPhysicalIntervention?.value?.[0]?.average)
        const averageDurationPhysicalInterventionTotalSeconds = Math.floor(averageDurationPhysicalInterventionValue * 60)
        const averageDurationPhysicalInterventionMinutes = Math.floor(averageDurationPhysicalInterventionTotalSeconds / 60)
        const averageDurationPhysicalInterventionSeconds = averageDurationPhysicalInterventionTotalSeconds % 60
        const newLabel = averageDurationPhysicalInterventionMinutes + 'm ' + averageDurationPhysicalInterventionSeconds + 's'
        setAverageDurationPhysicalInterventionLabel(newLabel)

        setAverageDurationPhysicalIntervention(newLabel)
      }
    }

    // Average Duration Physical Intervention
    if (reportData.totalDurationPhysicalIntervention !== undefined) {
      const totalDurationPhysicalIntervention = reportData.totalDurationPhysicalIntervention
      if (totalDurationPhysicalIntervention?.value?.[0]?.total) {
        setTotalDurationPhysicalIntervention(totalDurationPhysicalIntervention)

        // convert minutes to a string with hours and minutes
        const totalDurationPhysicalInterventionValue = totalDurationPhysicalIntervention?.value?.[0]?.total
        const totalDurationPhysicalInterventionHours = Math.floor(totalDurationPhysicalInterventionValue / 60)
        const totalDurationPhysicalInterventionMinutes = totalDurationPhysicalInterventionValue % 60
        const totalDurationPhysicalInterventionLabel = totalDurationPhysicalInterventionHours + 'h ' + totalDurationPhysicalInterventionMinutes + 'm'
        setTotalDurationPhysicalInterventionLabel(totalDurationPhysicalInterventionLabel)

      }
    }

    if (reportData.breathingMonitoredByStudentGraph !== null) {
      const breathingMonitoredByStudentGraph = reportData.breathingMonitoredByStudentGraph

      const breathingMonitoredByStudentGraphLabels = []
      const breathingMonitoredByStudentGraphData = []

      for (let x in breathingMonitoredByStudentGraph) {
        if (x === 'null') { x = null }
        breathingMonitoredByStudentGraphLabels.push((breathingMonitoredByStudentGraph[x].name || 'n/a'))
        breathingMonitoredByStudentGraphData.push(breathingMonitoredByStudentGraph[x].count)
      }

      setBreathingMonitoredByStudentGraph([breathingMonitoredByStudentGraphData, breathingMonitoredByStudentGraphLabels])
    }

    if (reportData.breathingMonitoredByYearGroupGraph !== null) {
      const breathingMonitoredByYearGroupGraph = reportData.breathingMonitoredByYearGroupGraph

      const breathingMonitoredByYearGroupGraphLabels = []
      const breathingMonitoredByYearGroupGraphData = []

      for (let x in breathingMonitoredByYearGroupGraph) {
        if (x === 'null') { x = null }
        breathingMonitoredByYearGroupGraphLabels.push((breathingMonitoredByYearGroupGraph[x].name || 'n/a'))
        breathingMonitoredByYearGroupGraphData.push(breathingMonitoredByYearGroupGraph[x].count)
      }

      setBreathingMonitoredByYearGroupGraph([breathingMonitoredByYearGroupGraphData, breathingMonitoredByYearGroupGraphLabels])
    }

    if (reportData.breathingMonitoredByStudentGroupGraph !== null) {
      const breathingMonitoredByStudentGroupGraph = reportData.breathingMonitoredByStudentGroupGraph

      const breathingMonitoredByStudentGroupGraphLabels = []
      const breathingMonitoredByStudentGroupGraphData = []

      for (var x in breathingMonitoredByStudentGroupGraph) {
        if (x === 'null') { x = null }
        breathingMonitoredByStudentGroupGraphLabels.push((breathingMonitoredByStudentGroupGraph[x].groupname || 'n/a'))
        breathingMonitoredByStudentGroupGraphData.push(breathingMonitoredByStudentGroupGraph[x].count)
      }

      setBreathingMonitoredByStudentGroupGraph([breathingMonitoredByStudentGroupGraphData, breathingMonitoredByStudentGroupGraphLabels])
    }

    // Restricted Physical Intervension
    if (reportData.numberIncidentsRestrictedInterventionUsed !== null) {
      setNumIncidentsRestrictedInterventionUsed(reportData.numberIncidentsRestrictedInterventionUsed)
    }

    // incidentDamageCount
    const incidentDamageCount = reportData.incidentDamageCount
    if (incidentDamageCount?.length) {
      const incidentDamageCountLabels = incidentDamageCount.map((data, index) => {

        var label = 'n/a'
        switch (data.questionKey) {
          case 'hurtingSelf':
            label = 'Hurting self'
            break
          case 'hurtingOthers':
            label = 'Hurting others'
            break
          case 'propertyDamage':
            label = 'Damage to property'
            break
          case 'commitOffence':
            label = 'Committing an offence'
            break
          case 'behaviour':
            label = 'Behaviour we are trying to support'
            break
        }


        return label
      })
      const incidentDamageCountValue = incidentDamageCount.map((data, index) => {
        return data.count
      })
      setIncidentDamageCountData([incidentDamageCountValue, incidentDamageCountLabels])
    }

       // Child injuries
    if (reportData?.numIncidentsInvolvingInjuryToChild !== null) {
      const numIncidentsInvolvingInjuryToChild =
        reportData?.numIncidentsInvolvingInjuryToChild;

      setNumIncidentsInvolvingInjuryToChild(numIncidentsInvolvingInjuryToChild);
    }

    // Staff injuries
    if (reportData?.numIncidentsInvolvingInjuryToStaff !== null) {
      const numIncidentsInvolvingInjuryToStaff =
        reportData?.numIncidentsInvolvingInjuryToStaff;

      setNumIncidentsInvolvingInjuryToStaff(numIncidentsInvolvingInjuryToStaff);
    }

    // Other injuries
    if (reportData?.numIncidentsInvolvingInjuryToOthers !== null) {
      const numIncidentsInvolvingInjuryToOthers =
        reportData?.numIncidentsInvolvingInjuryToOthers;

      setNumIncidentsInvolvingInjuryToOthers(
        numIncidentsInvolvingInjuryToOthers,
      );
    }



  }, [reportData])

  let componentRef = null
  let setComponentRef = (ref) => {
    componentRef = ref;
  };

  let reactToPrintContent = () => {
    return componentRef;
  };
  const reactToPrintTrigger = () => {
    return <ActionButton label={<FontAwesome icon={['fal', 'print']} size='xs' />} className='noprint' plain target='_self' />
  };




  return (
    <Box ref={setComponentRef} direction='column' gap='small' round='small'>
          {/* <Box direction='row' align='center' gap='small' margin={{ right: 'small' }}>
                  <Text color='white' size="large" weight='bold'>To Date:</Text>
                </Box> */}
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto', 'auto'],
            large: ['auto', 'auto', 'auto', 'auto'],
            xlarge: ['auto', 'auto', 'auto', 'auto']
          }}
          gap='small'
          pad='xxsmall'
        >

          <SimpleCounterSmall
            count={reportData?.totalNumberOfIncidents ? String(reportData?.totalNumberOfIncidents) : '0'}
            label='Total Number of Incidents'
            onClick={() =>
              openAnalyticsWithFilters([
                {
                "key": "studentName",
                "operator": "is",
                "response": props.userId,
                "relation": null
              }
            ])
            }
          />
          <SimpleCounterSmall
            count={reportData?.numberIncidentsNoPhysicalInterventionUsed ? String(reportData?.numberIncidentsNoPhysicalInterventionUsed) : '0'}
            label='# Incidents that did not include Physical Intervention'
            onClick={() =>
              openAnalyticsWithFilters([{
                "key": "studentName",
                "operator": "is",
                "response": props.userId,
                "relation": null
              }, {
                "key": "physicalInterventionUsed",
                "operator": "is not",
                "response": "Yes",
                "relation": null
              }
            ])
            }
          />
          <SimpleCounterSmall
            count={reportData?.numberIncidentsNoPhysicalInterventionUsed ? String(reportData?.numberIncidentsPhysicalInterventionUsed) : '0'}
            label='# Incidents involving Physical Intervention'
            onClick={() =>
              openAnalyticsWithFilters([{
                "key": "studentName",
                "operator": "is",
                "response": props.userId,
                "relation": null
              }, {
                "key": "physicalInterventionUsed",
                "operator": "is",
                "response": "Yes",
                "relation": null
              }
            ])
            }
          />
          <SimpleCounterSmall
            count={reportData?.numberIncidentsRestrictedInterventionUsed ? String(reportData?.numberIncidentsRestrictedInterventionUsed) : '0'}
            label={<Text># Incidents involving <Text weight="bold">Restrictive</Text> Physical Intervention</Text>}
            onClick={() =>
              openAnalyticsWithFilters([{
                "key": "studentName",
                "operator": "is",
                "response": props.userId,
                "relation": null
              }, {
                "key": "restrictedPhysicalInterventionUsed",
                "operator": "is",
                "response": "Yes",
                "relation": null
              }
            ])
            }
          />
        </ResponsiveGrid>
        {props.showAllStats && <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto', 'auto', 'auto'],
            large: ['auto', 'auto', 'auto'],
            xlarge: ['auto', 'auto', 'auto']
          }}
          gap='small'
        >
            <ActionList
              border={false}
              title='Most Common Locations for Intervention'
              pad={{ horizontal: 'none', vertical: 'xsmall' }}
              data={commonInterventions}
              onClick={(item) => {
                 openAnalyticsWithFilters([{
                  "key": "studentName",
                  "operator": "is",
                  "response": props.userId,
                  "relation": null
                }, {
                  "key": item.key,
                  "operator": item.operator || 'is',
                  "response": item.response,
                  "relation": null
                }
              ])
             }}
            />

             <ActionList
              border={false}
              title='Most Frequent Physical Technique'
              pad={{ horizontal: 'none', vertical: 'xsmall' }}
              data={commonPhysicalTechniques}
              onClick={(item) => {
                 openAnalyticsWithFilters([{
                  "key": "studentName",
                  "operator": "is",
                  "response": props.userId,
                  "relation": null
                }, {
                  "key": item.key,
                  "operator": item.operator || 'is',
                  "response": item.response,
                  "relation": null
                }
              ])
             }}
            />

            <ActionList
              border={false}
              title='Most Frequent Deescalation Technique'
              pad={{ horizontal: 'none', vertical: 'xsmall' }}
              data={commonDeescalationTechniques}
              onClick={(item) => {
                 openAnalyticsWithFilters([{
                  "key": "studentName",
                  "operator": "is",
                  "response": props.userId,
                  "relation": null
                }, {
                  "key": item.key,
                  "operator": item.operator || 'is',
                  "response": item.response,
                  "relation": null
                }
              ])
             }}
            />

          <Box
            direction='column'
            flex='grow'
            gap='medium'
          >

            <SimpleCounterSmall
              count={String(numIncidentsRestrictedInterventionUsed || 0)}
              label='Incidents involving restrictive physical intervention'
              onClick={() =>
                openAnalyticsWithFilters([{
                  "key": "studentName",
                  "operator": "is",
                  "response": props.userId,
                  "relation": null
                }, {
                  "key": "restrictedPhysicalInterventionUsed",
                  "operator": "is",
                  "response": "Yes",
                  "relation": null
                }
              ])
              }
            />

          </Box>
          <Box
            direction='column'
            flex='grow'
            gap='medium'
          >

            <Box
              background='white'
              direction='column'
              flex='grow'
              pad='small'
              // height='xsmall'
              round='small'
            >
              <Text size='xxlarge' weight='bold'>
                {averageDurationPhysicalInterventionLabel || 'n/a'} </Text>
              <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
              <Text size='small'>Avg. Duration of Physical Interventions</Text>
            </Box>

          </Box>
          <Box
            direction='column'
            flex='grow'
            gap='medium'
          >

            <Box
              background='white'
              direction='column'
              flex='grow'
              pad='small'
              // height='xsmall'
              round='small'
            >
              <Text size='xxlarge' weight='bold'>{totalDurationPhysicalInterventionLabel} </Text>
              <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
              <Text size='small'>Total Duration of Physical Interventions</Text>
            </Box>
          </Box>


        </ResponsiveGrid>}
        {props.showAllStats && <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto']
          }}
          gap='small'
        >

          <Box
            background='white'
            direction='column'
            pad='small'
            round='small'
          >
            <Text size='medium' weight='bold'>Total Number of Incidents</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
            <Bar
              data={damageReportChartData}
              height={10}
              legend={{ display: false }}
              width={50}
              // onElementsClick={(event) => {
              //   const { _datasetIndex, _index } = event[0];
              //   let key = 'location';
              //   let value = props?.reportData?.totalNumberOfIncidentsByLocation?.[_index]?.response
              //   // props.addFilter(key, value);
              //   openAnalyticsWithFilters([{
              //     "key": "studentName",
              //     "operator": "is",
              //     "response": props.userId,
              //     "relation": null
              //   }, {
              //     "key": key,
              //     "operator": "is",
              //     "response": value,
              //     "relation": null
              //   }
              // ])
              // }}
            />
          </Box>
        </ResponsiveGrid>}

        {props.showAllStats && <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto', 'auto', 'auto', 'auto'],
            large: ['auto', 'auto', 'auto', 'auto'],
            xlarge: ['auto', 'auto', 'auto', 'auto'],
          }}
          gap="small"
        >
          <SimpleCounterSmall
            count={String(numIncidentsInvolvingInjuryToChild || 0)}
            label={
              terms?.serviceUser
                ? `Incidents involving injury to ${
                    terms?.serviceUser?.charAt(0)?.toUpperCase() +
                    terms?.serviceUser?.slice(1)
                  }`
                : 'Incidents involving injury to Student'
            }
            onClick={() =>
              openAnalyticsWithFilters([
                {
                  key: 'studentName',
                  operator: 'is',
                  response: props.userId,
                  relation: null,
                },
                {
                  key: 'injuryToStudent',
                  operator: 'is',
                  response: 'Yes',
                  relation: null,
                },
              ])
            }
          />
          <SimpleCounterSmall
            count={String(numIncidentsInvolvingInjuryToStaff || 0)}
            label="Incidents involving injury to staff member"
            onClick={() =>
              openAnalyticsWithFilters([
                {
                  key: 'studentName',
                  operator: 'is',
                  response: props.userId,
                  relation: null,
                },
                {
                  key: 'injuryToStaff',
                  operator: 'is',
                  response: 'Yes',
                  relation: null,
                },
              ])
            }
          />
          <SimpleCounterSmall
            count={String(numIncidentsInvolvingInjuryToOthers || 0)}
            label="Incidents involving injury to other"
            onClick={() =>
              openAnalyticsWithFilters([
                {
                  key: 'studentName',
                  operator: 'is',
                  response: props.userId,
                  relation: null,
                },
                {
                  key: 'injuryToOther',
                  operator: 'is',
                  response: 'Yes',
                  relation: null,
                },
              ])
            }
          />
        </ResponsiveGrid>}
      </Box>
  )
}

export default ServiceUserProfileStats
